import request from './request';

/**
 * 左侧分类数据
 * @param {stype} stype 0->商品分类，1->工艺部件，2->标准数据库，3->特殊体型
 */
export const apiList = (stype) =>
    request({
        url: '/apipad.php/Mysqls/mysqls_cate',
        method: 'post',
        data: {stype},
    });

export function getAreaList(data) {//获取地址信息
    return request({
        url: "apipad.php/public/getAreaData",
        method: "post",
        data,
    });
}
